import React, { Component } from "react";
import styles from "./modal.scss";
import close from "../../../../assets/images/close-icon.svg";

class hireModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: ""
    };
  }

  onMessageChange = event => {
    this.setState({
      ...this.state,
      message: event.target.value
    });
  };

  render() {
    const { message } = this.state;

    return (
      <div className={styles.modalcontainer}>
        <img
          src={close}
          className={styles.closebutton}
          onClick={() => this.props.onHide()}
        />
        <div className={styles.modalcontent}>
          <div className={styles.header}>
            <h2 className={styles.title}>Decline Proposal</h2>
          </div>
          <div className={styles.intro}>
            <p className={styles.centered}>
              She will receive a notification that you declined her pitch, but
              you can also add a personal message below.
            </p>
          </div>
          <div className={styles.divider}>
            <textarea
              className={styles.message}
              onChange={this.onMessageChange}
              value={message}
              placeholder="Tell the member why you're not interested in her proposal. (Optional)"
            />
          </div>
          <div className={styles.intro}>
            <div>
              <button
                className={styles.acceptButton}
                onClick={() => {
                  this.props.modalClick(message);
                  this.props.onHide();
                }}
              >
                Decline
              </button>
            </div>
            <div className={styles.buttonContainer}>
              <span className={styles.link} onClick={() => this.props.onHide()}>
                Wait, nevermind!
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default hireModal;



// WEBPACK FOOTER //
// ./src/routes/employer/memberProfile/components/declineModal.js